import React, { Dispatch, SetStateAction, useEffect } from 'react'
import { useForm, FormProvider } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

import { Typography, Box, styled, sx, Button } from 'shared-components/material/core'
import { TextInput } from 'shared-components/inputs'
import { CenteredForm } from 'shared-components/layout'

const ProcessingOptionsContainer = styled(Box)((
    sx({
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        width: '100%'
    })
))

const schema = yup.object({
    clientEmails: yup.string().required('Client E-Mails are required'),
    customMessage: yup.string().required('Custom Message is required'),
}).required()

type FormData = {
    clientEmails: string,
    customMessage: string, 
}

type ClientEmailProps = {
    clientEmails: string,
    customMessage: string,
    passSetupData: (data: FormData) => void,
    setOpenKickOffModal: Dispatch<SetStateAction<boolean>>,
}

export default function ClientEmail({
    clientEmails,
    customMessage,
    passSetupData,
    setOpenKickOffModal
}: ClientEmailProps) {

    const methods = useForm({
        defaultValues: { //create empty init values to avoid uncontrolled to controlled warning
            clientEmails: '',
            customMessage: '',
        },
        resolver: yupResolver(schema),
    })

    const { handleSubmit, setValue, formState: { errors } } = methods


    useEffect(() => {
        if (clientEmails || customMessage) {
            setValue('clientEmails', clientEmails)
            setValue('customMessage', customMessage)
        }
    }, [clientEmails, customMessage])

    const onSubmit = (data: FormData) => {
        passSetupData(data)
    }

    return (
        <ProcessingOptionsContainer>
            <CenteredForm>
                <FormProvider {...methods}>
                    <Typography variant="h5" component="h2" sx={{ mt: 2}}>
                        Email Setup
                    </Typography>
                    <>
                        <TextInput
                            name="clientEmails"
                            label="Client E-Mails (comma separated)"
                            required
                            error={errors.clientEmails !== undefined ? true : false }
                            errorMessage={errors.clientEmails ? errors.clientEmails.message : undefined}
                            sx={{ mb: 1 }}
                        />
                        <TextInput
                            name="customMessage"
                            label="Client Instructions"
                            required
                            error={errors.customMessage !== undefined ? true : false }
                            errorMessage={errors.customMessage ? errors.customMessage.message : undefined}
                            multiline
                            rows={10}
                        />
                    </>
                    
                </FormProvider>
            </CenteredForm>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                pt: 2,
                width: '100%'
            }}>
                <Button
                    onClick={() => setOpenKickOffModal(false)}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>
                <Button 
                    onClick={handleSubmit(onSubmit)}
                    variant="contained"
                >
                    Next
                </Button>
            </Box>
        </ProcessingOptionsContainer>
    )
}
